import { render, staticRenderFns } from "./hoyesYellow.vue?vue&type=template&id=cad5c6e4"
import script from "./hoyesYellow.vue?vue&type=script&lang=js"
export * from "./hoyesYellow.vue?vue&type=script&lang=js"
import style0 from "./hoyesYellow.vue?vue&type=style&index=0&id=cad5c6e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports